import React from 'react'
import styles from './QuickExportDialog.scss'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {interfaceBase} from 'lib/styleguide/base.scss'
import {ExportFormatContainer} from 'common/ExportFormats'
import {formatsForObjectType} from 'lib/exportFormats'
import {EXPORT_DIALOG} from '../ExportDialog'
import {CTA} from 'common/styleguide/CTA'
import cx from 'classnames'

export class QuickExportDialog extends React.PureComponent {
  moreOptionsClicked = (e) => {
    e.preventDefault()

    const {onRequestClose, showDialog} = this.props
    showDialog(EXPORT_DIALOG)
    onRequestClose()
  }

  render () {
    const {route, onRequestClose, format} = this.props

    const f = formatsForObjectType('route').get(format)

    return (
      <ModalOverlay
        title={<span>Export <strong>{f.ext.toUpperCase()} file</strong></span>}
        maxWidth='400px'
        onRequestClose={onRequestClose}>
        <div className={cx(interfaceBase, styles.QuickExportDialog)}>
          <ExportFormatContainer
            troute={route}
            objectType='route'
            f={f} />
          <CTA link margins={false} onClick={this.moreOptionsClicked}>Other Formats</CTA>
        </div>
      </ModalOverlay>
    )
  }
}
